import * as Yup from "yup";

const DocumentDropOffValidation = Yup.object().shape({
  notes: Yup.string().max(500, "Maximum of 500 characters are accepted"),
  documents: Yup.array()
    .required("Document(s) are required!")
    .min(1, "Document(s) are required!"),
});

export default DocumentDropOffValidation;
